/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/chickenh/getUserInfo',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    exp_apply : '/api/chickenh/buy',
    my_task : '/api/UserTask/GetDict',
    buy : '/api/chickenh/buy',//购买经验和道具 "giftId": 1:经验,2:599鸡王,32:2399包
    task_apply : '/api/chickenh/commit',//领取奖励
    task599_apply : '/api/UserTask/RwTaskId',//完成任务领奖
    coin_apply : '/api/chickenh/buyCoin',//购买金鸡币
    query_score : '/api/chickenh/queryScore',//军威值查询
    invite_rate : '/api/chickenh/InviteRate',//邀请有礼进度
    invite_list : '/api/chickenh/InviteList',//邀请列表
    invite : '/api/share/getCode',//邀请
    invite_info : '/api/share/getNickName',
    apply_invite : '/api/share/bindCode',
    giftxy_apply : '/api/chickenh/GiftXy',//领争霸相遇礼
    gifthy_apply : '/api/chickenh/GiftHy',//领争霸活跃礼
    giftkk_apply : '/api/chickenh/GiftKk',//领争霸慷慨礼
    shop_list : '/api/gift/list?type=2&orderNum=true',//积分兑换商城
    trade : '/api/chickenh/reward',//积分兑换
    record : '/api/Order/GetOrderList?type=2',//兑换记录
    query_skin : '/api/Chickenh/QuerySkin',//查询封灵玉
    rank : '/api/Chickenh/TopList',//排行榜
}


export const apiUserinfo = p => post(user_api.userinfo, p);
export const apiUserbind = p => post(user_api.bind, p);
export const apiUserquery = p => get(user_api.queryplayer, p);
export const apiTaskinfo = p => get(user_api.my_task, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const api599Apply = p => post(user_api.task599_apply, p);
export const apiExpApply = p => post(user_api.exp_apply, p);
export const apiChickenBuy = p => post(user_api.buy, p);
export const apiCoinBuy = p => post(user_api.coin_apply, p);
export const apiQueryScore = p => get(user_api.query_score, p);
export const apiInviteTask = p => get(user_api.invite_rate, p);
export const apiInviteList = p => get(user_api.invite_list, p);
export const apiInviteCode = p => get(user_api.invite, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiInviteApply = p => post(user_api.apply_invite, p);
export const apiGiftXy = p => post(user_api.giftxy_apply, p);
export const apiGiftHy = p => post(user_api.gifthy_apply, p);
export const apiGiftKk = p => post(user_api.giftkk_apply, p);
export const apiShopList = p => get(user_api.shop_list, p);
export const apiTrade = p => post(user_api.trade, p);
export const apiTradeRecord = p => get(user_api.record, p);
export const apiQuerySkin = p => get(user_api.query_skin, p);
export const apiRankList = p => get(user_api.rank, p);